import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 30" fill="currentColor">
    <path d="M5.072 3.024c-1.7 0-3 1.4-3 3V20.324c0 1.7 1.4 3 3 3h2c.6 0 1 .5 1 1v3.6l4.3-4.3c.2-.2.4-.3.7-.3h12.2c1.7 0 3-1.4 3-3v-14.2-.1c0-1.7-1.4-3-3-3h-20.2z" />
  </svg>
);
